// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://vnxgnjanjoritfebezsh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZueGduamFuam9yaXRmZWJlenNoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTU4OTIyNDAsImV4cCI6MjA3MTQ2ODI0MH0.kYGJ6Kyy5u0ZyLWPk8PlrrifncyfFtrzOOz8aItLjqQ";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});